/**
 * Проверяет состоит ли строка только из цифр
 */
export const toNumberIfDigits = <T>(value: string, defaultValue: T): number | string | T => {
    if (/^\d+$/.test(value)) {
        return Number(value)
    } else {
        return defaultValue || value
    }
}
